import { FormRenderProps } from '@progress/kendo-react-form';
import { ContentTypeFieldResponse } from '@cs-cms/types';
import type { FieldInteractionsDependentFieldsClearedContext, FieldInteractionsLookupFilledContext } from '@cs-cms/ui';
import { MASTER_FIELD_PREFIX } from '../model/masterFieldConstants';

const clearCompanionPrefixedFields = (
  sourceFieldNames: string[],
  formRenderProps: FormRenderProps,
  contentTypeFields: ContentTypeFieldResponse[]
): void => {
  const knownFieldNames = new Set(contentTypeFields.map(field => field.name));
  sourceFieldNames.forEach(fieldName => {
    const companionFieldName = `${MASTER_FIELD_PREFIX}${fieldName}`;
    if (knownFieldNames.has(companionFieldName)) {
      formRenderProps.onChange(companionFieldName, { value: null });
    }
  });
};

export const rtMasterFieldInteractionCallbacks = {
  onAfterFilledFieldsFromLookup: ({
    targetFieldNames,
    formRenderProps,
    contentTypeFields
  }: FieldInteractionsLookupFilledContext): void => {
    clearCompanionPrefixedFields(targetFieldNames, formRenderProps, contentTypeFields);
  },
  onAfterClearedDependentFields: ({
    clearedFieldNames,
    formRenderProps,
    contentTypeFields
  }: FieldInteractionsDependentFieldsClearedContext): void => {
    clearCompanionPrefixedFields(clearedFieldNames, formRenderProps, contentTypeFields);
  }
};
